import { IError } from '@riseart/interfaces';
import { Codes as ErrorCodes, Types as ErrorTypes, Messages as ErrorMessages } from './ErrorDefinitions.js';

/**
 * InvalidToken
 */
class InvalidToken extends Error implements IError {
  public previous: unknown;
  public code: string;
  public type: string;

  /**
   * Constructor
   *
   * @param {unknown} previous
   */
  constructor(previous?: unknown) {
    // Parent constructor
    super(ErrorMessages.INVALID_TOKEN);

    // Set the prototype explicitly
    Object.setPrototypeOf(this, InvalidToken.prototype);

    // Set error properties
    this.name = this.constructor.name;
    this.code = ErrorCodes.INVALID_TOKEN;
    this.type = ErrorTypes.INVALID_TOKEN;
    this.previous = previous;
  }
}

export { InvalidToken };
